import React from 'react';
import './StatusCard.css';

export default function StatusCard({ icon: Icon, title, body, children }) {
  return (
    <div className="card tp-status-card">
      <Icon size={24} strokeWidth={1.5} className="tp-status-card__icon" />
      <div>
        <h3 className="title-m">{title}</h3>
        <p className="body-m tp-status-card__body">{body}</p>
        {children}
      </div>
    </div>
  );
}
